import {useSelector} from "react-redux";

// return true if the user has ALL of the permission codes specified
export const usePermission = () => {
    const permissions = useSelector(state => state.userState.permissions);

    return (codes) => {
        
        // convert single string parameter to array
        if(typeof codes === 'string') {
            codes = [codes];
        }

        if(permissions && Array.isArray(codes)) {
            return codes.every(code =>
                permissions.some(x =>
                    (x === code) || (x.Permission && x.Permission.code === code)
                )
            );
        }

        return false;
    };
};

export const useAnyPermission = () => {
    const permissions = useSelector(state => state.userState.permissions);

    return (codes) => {
        if(permissions && Array.isArray(codes)) {
            return codes.some(code =>
                permissions.some(x =>
                    (x === code) || (x.Permission && x.Permission.code === code)
                )
            );
        }

        return false;
    };
};

export const usePublic = () => {
    const user = useSelector(state => state.userState.user);

    if(user) {
        return user.publicContext;
    }

    return false;
};

export const useEditContextNodeId = () => {
    const user = useSelector(state => state.userState.user);
    const permission = usePermission();

    return (contextNodeId) => {

        // TODO: We shouldn't allow editing here, in case
        // the unassigned data they want to edit is cross-organization...
        // They should still need to be able to see it?
        if(permission(['can_alter_unassigned_data', 'skips_data_segmentation'])) {
            return true;
        }
        
        if(!contextNodeId) {
            return false;
        }
        
        contextNodeId = Number(contextNodeId);

        if(user && user.editableContextNodeIds != null) {
            // Note these are not complete objects, they are subsets of ContextNodes
            // provided from the JWT Token
            if(user.editableContextNodeIds.some((x) => Number(x) === contextNodeId)) {
                return true;
            }
        }

        return false;
    }
};

export const useEditFileUpload = () => {
    const editContextNodeId = useEditContextNodeId();

    return (fileUpload) => {
        const contextNodeIds = fileUpload?.FileUploadContextNodes?.map(contextNode => contextNode?.contextNodeId);

        return contextNodeIds?.some(editContextNodeId) ?? false;
    }
};
